import { X_BUSINESS_GUID_KEY } from '@/common/constant';
import Api from '@/common/api';

export const autoSetXBusinessGuid = (
  lastBusinessGuid,
  preferredBusinessGuid,
  businessList = [],
) => {
  if (businessList.length === 0) return;
  if (localStorage.getItem(X_BUSINESS_GUID_KEY)) return null;

  let guid = null;
  if (businessList.find((_) => _.guid === lastBusinessGuid)) {
    guid = lastBusinessGuid;
  } else if (businessList.find((_) => _.guid === preferredBusinessGuid)) {
    guid = preferredBusinessGuid;
  } else {
    guid = businessList?.[0]?.guid;
  }
  if (guid) {
    Api.getApi().setXBusinessGuid(guid);
    Api.getApiIRS().setXBusinessGuid(guid);
    localStorage.setItem(X_BUSINESS_GUID_KEY, guid);
  }
  return guid;
};

export const setXBusinessGuid = (guid) => {
  Api.getApi().setXBusinessGuid(guid);
  Api.getApiIRS().setXBusinessGuid(guid);
  localStorage.setItem(X_BUSINESS_GUID_KEY, guid);
};

export const getXBusinessGuid = () => {
  const guid = localStorage.getItem(X_BUSINESS_GUID_KEY) || null;
  if (guid) {
    Api.getApi().setXBusinessGuid(guid);
    Api.getApiIRS().setXBusinessGuid(guid);
  }
  return guid;
};

export const removeXBusinessGuid = () => {
  localStorage.removeItem(X_BUSINESS_GUID_KEY);
  Api.getApi().setXBusinessGuid(null);
  Api.getApiIRS().setXBusinessGuid(null);
};
